import { Pipe, PipeTransform } from '@angular/core';
import { StringUtils } from '../utils/string.utils';

@Pipe({ name: 'getInitials' })
export class InitialsFromNamePipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    return StringUtils.getInitials(value);
  }
}
